import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-8">
            <div className="mb-6">
              <Link
                to="/register"
                className="inline-flex items-center text-sm text-blue-600 hover:text-blue-500"
              >
                <ArrowLeftIcon className="h-4 w-4 mr-2" />
                Back to Registration
              </Link>
            </div>

            <h1 className="text-3xl font-bold text-gray-900 mb-8">
              Terms and Conditions
            </h1>

            <div className="prose max-w-none">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                1. Acceptance of Terms
              </h2>
              <p className="text-gray-700 mb-6">
                By accessing and using the GCRA Training Portal, you accept and agree to be bound by the terms and provision of this agreement.
              </p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                2. Use License
              </h2>
              <p className="text-gray-700 mb-6">
                Permission is granted to temporarily access the materials on GCRA Training Portal for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
              </p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                3. User Account
              </h2>
              <p className="text-gray-700 mb-6">
                You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer. You agree to accept responsibility for all activities that occur under your account or password.
              </p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                4. Course Registration
              </h2>
              <p className="text-gray-700 mb-6">
                Course registration is subject to availability and eligibility requirements. GCRA reserves the right to cancel or modify courses at any time.
              </p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                5. Privacy
              </h2>
              <p className="text-gray-700 mb-6">
                Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Portal.
              </p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                6. Modifications
              </h2>
              <p className="text-gray-700 mb-6">
                GCRA may revise these terms of service at any time without notice. By using this Portal, you are agreeing to be bound by the then current version of these terms of service.
              </p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                7. Contact Information
              </h2>
              <p className="text-gray-700 mb-6">
                If you have any questions about these Terms and Conditions, please contact us at support@gcra.gov.za
              </p>

              <div className="mt-8 p-4 bg-gray-50 rounded-md">
                <p className="text-sm text-gray-600">
                  Last updated: {new Date().toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
